import ScreenCyclesTable from '../../../../components/ScreenCyclesTable/ScreenCyclesTable';
import { useCompletedCyclesInteractor } from './interactor';
import CycleStatus from '../../../../enums/cycle-status.enum';
import Modal from '../../../../components/Modal/Modal';
import CycleSettings from '../../../../components/CycleSettings/CycleSettings';
import { useTranslation } from 'react-i18next';
import SpinnerLoader from '../../../../components/SpinnerLoader/SpinnerLoader';
import DuplicateCycleModal from '../../../../components/DuplicateCycleModal/DuplicateCycleModal';

export const CompletedCycles = () => {
  const {
    cycles,
    isLoading,

    cycleActions,

    //cycle settings
    cycleIdSettings,
    cycleNameSettings,
    openSelectedCycleSettings,
    closeSelectedCycleSettings,

    //delete cycle from screen
    cycleIdDelete,
    closeSelectedCycleDelete,
    onAcceptSelectedCycleDelete,

    //multi-duplicate cycle
    cycleIdDuplicate,
    cycleNameDuplicate,
    closeSelectedCycleDuplicate,
    onCycleDuplicated,
  } = useCompletedCyclesInteractor();

  const { t } = useTranslation();

  if (!cycles.length && isLoading) {
    return (
      <div className="flex flex-row items-center justify-center">
        <SpinnerLoader />
      </div>
    );
  }

  if (!cycles.length && !isLoading) {
    return null;
  }

  return (
    <div className="relative flex flex-col overflow-hidden rounded-lg border border-foggy-mist bg-white p-3 shadow-15 dark:border-strokedark dark:bg-boxdark">
      <div className="c-screen__header min-xsm:flex-row flex w-full items-center justify-between gap-x-2 pb-5 max-xsm:flex-col">
        <span className="c-screen__name text-base font-bold max-md:pb-2 md:text-xl">
          {t('labels.completedCycles')}
        </span>
      </div>

      {!!cycles.length && (
        <ScreenCyclesTable
          openSettings={openSelectedCycleSettings}
          screenCycles={cycles}
          actionsButtons={cycleActions}
          status={CycleStatus.Completed}
        />
      )}

      <Modal
        modalTitle="Cycle deletion"
        isVisible={!!cycleIdDelete}
        content="Are you sure you want to delete this cycle?"
        acceptBtnText="Delete"
        onClose={closeSelectedCycleDelete}
        onAccept={onAcceptSelectedCycleDelete}
        showAcceptBtn
        showCancelBtn
      />

      {!!cycleIdSettings && (
        <CycleSettings isVisible={!!cycleIdSettings} onClose={closeSelectedCycleSettings} cycleId={cycleIdSettings} cycleName={cycleNameSettings} />
      )}

      <DuplicateCycleModal
        cycleId={cycleIdDuplicate}
        cycleName={cycleNameDuplicate}
        isVisible={!!cycleIdDuplicate}
        onClose={closeSelectedCycleDuplicate}
        onDuplicated={onCycleDuplicated}
      />
    </div>
  );
};
